const TimerSlider = ({sliderWidth}) => {
    return (
        <div className="timer-slider-container">
            <div className="timer-slider bg-primary" style={{ width: sliderWidth }}></div>
        </div>
    )
}
export default TimerSlider;